import React from "react";
import { DetailInvoiceCard } from "./DetailTopUpInvCard";
import { BillingUIProvider } from "./DetailTopUpInvUIContext";

export function DetailTopUpInvPage({
  history,
  match: {
    params: { id },
  },
}) {
  const billingUIEvents = {
    newBillingIndividuButtonClick: () => {
      history.push("/billing/individual/new");
    },
    newBillingOrganizationButtonClick: () => {
      history.push("/billing/organization/new");
    },
    openEditBillingIndividualPage: (id) => {
      history.push(`/billing/individual/${id}/edit`);
    },
    openEditBillingOrganizationPage: (id) => {
      history.push(`/billing/organization/${id}/edit`);
    },
    openDeleteBillingPage: (id) => {
      history.push(`/billing/${id}/delete`);
    },
  };

  return (
    <BillingUIProvider billingUIEvents={billingUIEvents}>
      <DetailInvoiceCard id={id} history={history} />
    </BillingUIProvider>
  );
}
